<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>
<!-- Main content Start -->
<div class="main-content">
  <!-- Breadcrumbs Start -->
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">{{ profile()?.designation || 'Management' }}</h1>
      <ul>
        <li>
          <a class="active" [routerLink]="['/']">Home</a>
        </li>
        <li>
          <a>About</a>
        </li>
        <li>{{ profile()?.name || 'Sri Balaji Educational Society' }}</li>
      </ul>
    </div>
  </div>
  <!-- Breadcrumbs End -->
  <!-- Blog Section Start -->
  <div *ngIf="profile()" class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <about-menu></about-menu>
        </div>
        <div class="col-lg-8">
          <div class="row">
            <div class="col-lg-12 mb-70">
              <div class="blog-item">
                <div class="blog-img">
                  <a href="#"><img [src]="profile()?.image" [alt]="profile()?.name || ''"></a>
                </div>
                <div class="blog-content">
                  <h3 class="blog-title">{{ profile()?.name }}</h3>
                  <div class="blog-meta">
                    <ul class="btm-cate">
                      <li *ngIf="profile()?.designation">
                        <div class="author">
                          <i class="fa fa-user-o"></i> {{ profile()?.designation }}
                        </div>
                      </li>
                      <li *ngIf="profile()?.institution">
                        <div class="tag-line">
                          <i class="fa fa-university"></i> {{ profile()?.institution }}
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="blog-desc">
                    <p *ngFor="let description of profile()?.descriptions" [innerHTML]="description"></p>
                  </div>
                  <p class="blog-desc" *ngFor="let desc of profile()?.additionalDescriptions">
                    {{ desc }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="blog-item">
            <div class="blog-content">
              <h3 class="blog-title">Our Colleges</h3>
              <div class="blog-table-wrap">
                <div *ngIf="isLoading()" class="table-state">Loading colleges...</div>
                <div *ngIf="!isLoading() && errorMessage()" class="table-state table-state-error">
                  {{ errorMessage() }}
                </div>
                <div *ngIf="!isLoading() && !errorMessage() && !rows().length" class="table-state">
                  No colleges available.
                </div>
                <table *ngIf="!isLoading() && !errorMessage() && rows().length" class="sheet-table" aria-label="Our Colleges">
                  <thead>
                    <tr>
                      <th *ngFor="let column of columns()">{{ column }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of rows()">
                      <td *ngFor="let column of columns()">
                        <ng-container [ngSwitch]="getColumnKind(column)">
                          <ng-container *ngSwitchCase="'location'">
                            <a *ngIf="row[column]" [href]="getCellUrl(column, row[column])" class="sheet-link sheet-link-location" target="_blank" rel="noopener noreferrer">
                              <i class="fa fa-map-marker"></i>
                              <span>{{ row[column] }}</span>
                            </a>
                            <ng-container *ngIf="!row[column]">{{ row[column] }}</ng-container>
                          </ng-container>
                          <ng-container *ngSwitchCase="'website'">
                            <a *ngIf="row[column]" [href]="getCellUrl(column, row[column])" class="sheet-link" target="_blank" rel="noopener noreferrer">{{ row[column] }}</a>
                            <ng-container *ngIf="!row[column]">{{ row[column] }}</ng-container>
                          </ng-container>
                          <ng-container *ngSwitchDefault>
                            {{ row[column] }}
                          </ng-container>
                        </ng-container>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Blog Section End -->
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->
